export default "__VITE_ASSET__397d86b2__"